module.exports = __webpack_public_path__ + "static/media/photo-u5.4a183059.jpg";